// @flow

const mergeDatasets = (datasets: Array<Object>): Object =>
  datasets.reduce(
    (memo, [key, value]) => {
      // eslint-disable-next-line no-param-reassign
      memo[key] = [...(memo[key] || []), ...value];
      return memo;
    },
    {
      addOns: [],
      categorizationInconsistencies: [],
      dataEntries: [],
      journalEntries: [],
      ledgerAccounts: [],
      transactionCategorizations: [],
    },
  );

export default mergeDatasets;
